import React from "react"
import FadeIn from "../general/fadein.tsx"
import FadeInTop from "../general/fadeintop.tsx"
import nanogurus from "../../images/nanogurus/nanogurus_large.png"
import calendar from "../../images/nanogurus/calendar.png"
import websitepreview from "../../images/nanogurus/websitepreview.png"
function NanoGurus() {
    const transition = {
        transition: ".3s"
    }
    const gui = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-10 pb-10 text-center font-semibold">Preview of the landing page.</p>

        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={websitepreview}
            alt="PythonAnywhere Terminal"
        />
    </div>)
    const face = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Code snippet that accesses our shared Google Calendar to populate the calendar page on the website and allow people to sign up for events.</p>

        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={calendar}
            alt="PetConnect Spreadsheet"
        />
    </div>)
    const top = (<div className="grid grid-cols-2 w-2/3 m-auto mt-5 ">
                    <div className="text-center m-auto p-5 ">
                        <img
                            className=" h-96 w-96 rounded-full object-fill object-center"
                            src={nanogurus}
                            alt="NanoGurus Logo"
                        />

                    </div>
                    <div className="flex flex-row text-left  p-5 items-center">
                        <div>
                            <h1 className="text-3xl sm:text-5xl font-semibold">NanoGurus Website</h1>
                            <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://nanogurus.org/">Live Site</a><br></br>
                            <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://github.com/Rishthegreat/NanoGurusWebsite">GitHub</a>
                            <p className="text-l sm:text-2xl">Created with Python Flask for the backend and CSS, HTML and JavaScript for the frontend.</p>
                        </div>
                    </div>
                </div>
            )
    return (
        <>
            <div className="divide-y divide-black/50 w-3/4 m-auto">
                <FadeInTop html={top}/>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={gui} left={true}/>
                    <FadeIn html={face} left={false}/>
                    
                    
                </div>
            </div>
        </>
    );
}
export default NanoGurus;